module.exports = __webpack_public_path__ + "static/img/shenpin.d0289dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/shenpin.jpg
// module id = f1fh
// module chunks = 0